import { isEveningBriefing } from './currentTimeCheckUtils';
import { CMMID_EVENING_BRIEFING, CMMID_MORNING_BRIEFING } from './constants';

/**
 * Helper function to determine which inbox briefing CMMID to use based on current time
 */
export function getCMMIDForInboxBriefing(): string {
    // Default to morning briefing CMMID for any other time
    return isEveningBriefing() ? CMMID_EVENING_BRIEFING : CMMID_MORNING_BRIEFING;
}
